import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import Text from 'components/Text';
import { Column } from 'components/Layout/Grid';
import TabNavigation from 'components/TabNavigation';
import { CTEInvoicingTable } from 'components/Table/CTEs/Invoicing';
import { cteInvoicingItemsModel, cteInvoicingModelComplete } from 'components/Table/CTEs/Invoicing/model';
import CTeInvoicingItems from 'components/Table/CTEs/Invoicing/CTeInvoicingItems';
import { cteModelComplete, billedFilter } from 'components/Table/CTEs/Listing/models';
import { CTEStockTable } from 'components/Table/CTEs/Stock/indext';
import { cteModelCompleteStockCte } from 'components/Table/CTEs/Stock/model';
import CTeStockItems from 'components/Table/CTEs/Stock/CTeStockItems';
import { cteStockItemsModel } from 'components/Table/CTEs/Stock/CTeStockItems/model';
import { CTETable } from 'components/Table/CTEs/Listing';

import { CTeInvoiceState, CTeStockState, EnumCTEsTabs } from 'models/CTEs';
import { useLoadCte } from 'hooks/useLoadCte';

export const CTEs: React.FC = () => {

  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);

  const navigate = useNavigate();
  const pageSize = 10;

  const { hasCte } = useLoadCte();

  useEffect(() => {
    if (!hasCte)
      navigate('/');
  }, [customer, user]);

  return (
    <>
      <Text size={24} className="color-primary font-bold">
        Healthlog
      </Text>

      <Column className="mt-3">
        <TabNavigation
          trackingKey="Abas CTEs"
          trackingEvent="CTEs"
          tabLabels={[
            {
              label: 'CT-e Conhecimento de Transporte Eletrônico',
              filter: billedFilter,
              trackingName: 'Aba_Listagem_Cte'
            },
            {
              label: 'Faturamento',
              filter: {},
              trackingName: 'Aba_Faturamento_Cte'
            },
            {
              label: 'Estoque',
              filter: {},
              trackingName: 'Aba_Estoque_Cte'
            }
          ]}
          pages={[
            <Column className="w-100 max-w-lg-100 flex-1" key={1}>
              <CTETable
                trackingKey="Grid CTEs"
                model={cteModelComplete()}
                pageSize={pageSize}
                currentTabId={EnumCTEsTabs.LISTAGEM_CTES}
                showExportButton={user?.userType === 'employee'}
                showDownloadInLotButton
              />
            </Column>,
            <Column className="w-100 max-w-lg-100 flex-1" key={2}>
              <CTEInvoicingTable
                trackingKey="Grid Faturamento CTEs"
                model={cteInvoicingModelComplete()}
                pageSize={pageSize}
                currentTabId={EnumCTEsTabs.FATURAMENTO_CTES}
                DropdownTemplate={(data: CTeInvoiceState) => (
                  <CTeInvoicingItems
                    key={data.identifier}
                    model={cteInvoicingItemsModel()}
                    cteInvoice={data}
                  />
                )}
              />
            </Column>,
            <Column className="w-100 max-w-lg-100 flex-1" key={3}>
              <CTEStockTable
                trackingKey="Grid Estoque CTEs"
                model={cteModelCompleteStockCte()}
                pageSize={pageSize}
                currentTabId={EnumCTEsTabs.ESTOQUE_CTES}
                DropdownTemplate={(data: CTeStockState) => (
                  <CTeStockItems
                    key={data.id}
                    model={cteStockItemsModel()}
                    cteStock={data}
                  />
                )}
              />
            </Column>
          ]}
        />
      </Column>
    </>
  );
};